import styled from '@emotion/styled';
import { PerformanceReportNetwork } from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement, ReactType } from 'react';

import { SPACING_UNIT } from '../../constant/spacing';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import AmazonIcon from '../primitive/AmazonIcon';
import FacebookIconWithOriginalColor from '../primitive/FacebookIconWithOriginalColor';
import GoogleIcon from '../primitive/GoogleIcon';
import TiktokIcon from '../primitive/TiktokIcon';
import YahooIcon from '../primitive/YahooIcon';

const networkSettings: Record<PerformanceReportNetwork, { icon: ReactType<{ size: number }>; title: string }> = {
  facebook: {
    icon: FacebookIconWithOriginalColor,
    title: `Facebook Creative Reporting`,
  },
  google: {
    icon: GoogleIcon,
    title: `Google Creative Reporting`,
  },
  amazon: {
    icon: AmazonIcon,
    title: `Amazon Creative Reporting`,
  },
  yahoo: {
    icon: YahooIcon,
    title: `Yahoo Creative Reporting`,
  },
  tiktok: {
    icon: TiktokIcon,
    title: `Tiktok Creative Reporting`,
  },
};

interface Props {
  className?: string;
  network: PerformanceReportNetwork;
}

const PerformanceReportNetworkWithIcon = ({ network, className }: Props & ClassAttributes<HTMLElement>) => {
  const Icon = networkSettings[network].icon;
  const title = networkSettings[network].title;
  return (
    <TitleWithIcon className={className}>
      <Icon size={24} />
      <Title>{title}</Title>
    </TitleWithIcon>
  );
};

const TitleWithIcon = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'row',
  }),
});

const Title = styled(Typography)({
  marginLeft: SPACING_UNIT * 2,
});
Title.defaultProps = { variant: 'body2' };

export default PerformanceReportNetworkWithIcon;
